import module from '../module';
import Constants from '../../../utils/CommonConstants';
import scopeUtils from '../../../utils/scope';
import {communicationService} from "../../../services/communicationService";
import {commandKeys} from "../../../shared/commandKeys";

function OrderCheckoutFullMixedController($scope, rootScope, cartService, session, $state, checkoutService, messageService, $translate) {

    this.$onInit = async () => {
        await $scope.init();
    };

    $scope.participantAmounts = [];
    $scope.cartTotal = 0;
    $scope.totalAllocated = 0;
    $scope.totalRemaining = $scope.cartTotal - $scope.totalAllocated;
    this._rootScope = rootScope;

    $scope.init = async () => {
        const cart = await cartService.getCart();
        $scope.cartId = cart.id;
        $scope.cartTotal = cart.cartTotal;
        $scope.participantAmounts = await cartService.getParticipantamounts(cart.id);
        $scope.totalAllocated = $scope.participantAmounts.map(r => r.amountToPay).reduce((total, item) => { return total + item; });
        $scope.totalRemaining = $scope.cartTotal - $scope.totalAllocated;
        scopeUtils.apply($scope);
    };

    $scope.amountToPayChange = async() => {
        $scope.totalAllocated = $scope.participantAmounts.map(r => r.amountToPay).reduce((total, item) => { return total + item; });
        $scope.totalRemaining = $scope.cartTotal - $scope.totalAllocated;
    };

    $scope.saveForLater = async() => {
        if($scope.totalAllocated > $scope.cartTotal){
            messageService.showErrorPopup($translate.instant('client.order.total_allocated'));
            return;
        }

        try {
            await cartService.updateAmountTopay($scope.participantAmounts);

            // get cart from server
            await cartService.getCart($scope.cartId,false);

            $state.go(Constants.RoutingStates.CART);
        } catch (error) {
            messageService.showErrorPopupForResponse(error);
        }
    };

    $scope.completeAndStartPaying = async() => {
        if($scope.totalAllocated > $scope.cartTotal){
            messageService.showErrorPopup($translate.instant('client.order.total_allocated'));
            return;
        }
        let update = await cartService.updateAmountTopay($scope.participantAmounts);
        if(update.data){
            await $scope.shopifyCheckout();
        }
    }

    $scope.shopifyCheckout = async() =>  {
        let confirmed = await cartService.startProcessCheckout();
        if (!confirmed)
            return null;

        let loadingDialog = await messageService.showLoading();
        try {
          const shopifyCheckoutInfo = await checkoutService.getShopifyCheckoutInfo();
          const myCartItems = shopifyCheckoutInfo.cartInfo.cartItems;

          if (shopifyCheckoutInfo.warningInfo) {
            loadingDialog.close();
            const continueCheckout = await messageService.showQuestionPopup(shopifyCheckoutInfo.warningInfo, '', $translate.instant('client.cart.continue_checkout'), $translate.instant('client.cart.checkout_review'));
            if (!continueCheckout) {
              return;
            }

            loadingDialog = await messageService.showLoading();
          }

          // TODO: if amountToPay of owner is 0 then make cartStatus = CHECKING_OUT, orderStatus = ORDERPAID by default
          if(shopifyCheckoutInfo.ownerPaid){
            loadingDialog.close();
            $state.go(Constants.RoutingStates.CART);
            return;
          }

          const existingShopifyCartItems = await communicationService.requestToParent(commandKeys.checkCartItems, {});
          const hasMyCartItems = existingShopifyCartItems.data.items.some(item => myCartItems.some(myCart => item.id === myCart.id));

          if (existingShopifyCartItems.data.item_count > 0) {
            if (hasMyCartItems) {
              loadingDialog.close();
              const continueCheckoutWhenMatch = await cartService.confirmContinueCheckoutWhenMatchCartItems();

              if (!continueCheckoutWhenMatch) {
                return;
              }
              loadingDialog = await messageService.showLoading();
            } else {
              loadingDialog.close();
              const continueCheckout = await cartService.confirmContinueCheckout();
              if (!continueCheckout) {
                return;
              }
              loadingDialog = await messageService.showLoading();
            }
          }

          const checkoutResult = await communicationService.requestToParent(commandKeys.checkoutCart, {
            cartInfo: shopifyCheckoutInfo.cartInfo
          });

          if (!checkoutResult.success) {
            messageService.showErrorPopup(checkoutResult.errorMessage);
          }
        } catch (e) {
          messageService.showErrorPopupForResponse(e);
        } finally {
          loadingDialog.close();
        }

    }
}

module.controller('Cartonomy.Order.CheckoutFullMixedController', ['$scope','$rootScope', 'CartService', 'Session', '$state', 'CheckoutService', 'Message', '$translate',OrderCheckoutFullMixedController]);



// WEBPACK FOOTER //
// ./src/modules/order/controllers/OrderCheckoutFullMixedController.js